<template>
    <div>
        <div class="sub_title">
            옵션/재고설정
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px">
                    <col>
                </colgroup>
                <tr>
                    <td class="c_t_title">옵션사용</td>
                    <td>
                        <div class="d_block">
                            <el-radio-group v-model="optionUse" @change="changeStatus('optionUse', optionUse)">
                                <el-radio :label="1" value="1">사용</el-radio>
                                <el-radio :label="0" value="0">사용안함</el-radio>
                            </el-radio-group>
                            <el-button class="title_btn ml10" type="warning"
                                       v-if="optionUse === 1" size="mini"
                                       @click="$modal.show('item-option-modal',{type : 'create'})">옵션 등록</el-button>
                        </div>
                        <div class="input_error" v-if="validation.hasError('optionList') && optionUse === 1">{{validation.firstError('optionList') }}</div>
                    </td>
                </tr>
                <tr v-if="optionUse === 0">
                    <td class="c_t_title">재고관리</td>
                    <td>
                        <div>
                            <el-radio-group v-model="stockUse" @change="parentChange('stockUse', stockUse)">
                                <el-radio :label="1" value="1">사용</el-radio>
                                <el-radio :label="0" value="0">사용안함</el-radio>
                            </el-radio-group>
                        </div>
                    </td>
                </tr>
                <tr v-if="optionUse === 0 && stockUse === 1">
                    <td class="c_t_title">재고수량</td>
                    <td>
                        <div class="d_block">
                            <el-input
                                placeholder="수량을 입력해주세요."
                                v-model="stock"
                                type="text"
                                @change="parentChange('stock', stock)"
                            />
                            <div class="input_error">{{validation.firstError('stock') }}</div>
                        </div>
                    </td>
                </tr>
            </table>

            <table class="mt20 text_center" v-if="optionUse === 1">
                <colgroup>
                    <col width="200px">
                    <col>
                </colgroup>
                <tr>
                    <th>노출순서</th>
                    <th>옵션명</th>
                    <th>판매상태</th>
                    <th>재고관리</th>
                    <th>재고수량</th>
                    <th v-if="checkUpdateOption()">옵션</th>
                </tr>
                <tr v-for="(op,index) in optionList" :key="`op${index}`" v-if="checkItemOption(op)">
                    <td>
                        <div>
                            {{ op.io_seq }}
                        </div>
                    </td>
                    <td>
                        <div>
                            {{ op.io_title }}
                        </div>
                    </td>
                    <td>
                        <div>
                            {{ op.io_is_selling === 1 ? '판매함' : '판매안함' }}
                        </div>
                    </td>
                    <td>
                        <div>
                            {{ op.ios_use === 1 ? '사용함' : '사용안함' }}
                        </div>
                    </td>
                    <td>
                        <div>
                            {{ op.ios_stock }}
                        </div>
                    </td>
                    <td v-if="checkUpdateOption()">
                        <div>
                            <el-button type="info"  size="mini"
                                       @click="$modal.show('item-option-modal',{data: op ,type : 'update',index : index})">
                                수정
                            </el-button>
                            <el-button type="danger" size="mini" @click="openDeleteConfirm(index)">삭제</el-button>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <item-option-modal></item-option-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from '@/mixins/util';
import {fcComma} from "@/mixins/common";
import ItemOptionModal from "../../../modal/ItemOptionModal";
import EventBus from "../../../../mixins/event-bus";
import alertMixins from "../../../../mixins/alertMixins";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    name: "ItemOptionLayout",
    mixins: [alertMixins],
    components: {ItemOptionModal},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,},
    },
    data() {
        return {
            contentShow: true,
            validatorArr: ['stockUse', 'stock','optionUse','optionList'],
            stock: '',
            stockUse: 0,
            optionUse : 0,
            optionList : [],
            checkOptionList: []
        }
    },
    created() {
        if (this.isItemData()) {
            this.settingItemData();
        }
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('ItemOptionLayout')

        EventBus.$on('addOptionRow', this.addOptionRow)
        EventBus.$on('updateOptionRow', this.updateOptionRow)
        this.checkValidator()
    },
    beforeDestroy() {
        EventBus.$off('addOptionRow')
        EventBus.$off('updateOptionRow')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        checkUpdateOption(){
            if(!util.isEmpty(this.itemData.optionList) && !util.isEmpty(this.itemData.optionList[0].i_idx)){
                return true
            }
        },
        addOptionRow(data) {
            this.optionList.push(data)

            this.$forceUpdate();
            this.parentChange('optionList', this.optionList);
            this.checkValidator()
        },
        updateOptionRow(data,index){
            this.optionList[index] = data

            this.$forceUpdate();
            this.parentChange('optionList', this.optionList);
        },
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        settingItemData() {
            this.optionList = this.itemData.optionList
            this.optionUse = this.itemData.optionUse
            this.stockUse = this.itemData.stockUse
            this.stock = this.itemData.stock
            this.checkItemOptionList()
        },
        changeStatus(type, value){
            if(type === 'optionUse' && value === 1){
                this.stockUse = 0
                this.stock = ''
                this.parentChange('stockUse', this.stockUse)
                this.parentChange('stock', this.stock)
            }
            if(type === 'optionUse' && value === 0 && !util.isEmpty(this.itemData.optionList)){
                util.Array.each(this.optionList, (data, index, arr) => {
                    data.io_is_delete = 1
                    data.status = 'update'
                })
                this.parentChange('optionList', this.optionList)
            }
            this.parentChange(type, value)
            this.checkValidator()
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        returnComma(name) {
            if(this[name] === '') {
                this[name] = '';
                return false;
            }
            let value = Number(String(this[name]).replace(/[^0-9]/g,''))
            this[name] = fcComma(value);
        },
        checkValidator() {
            this.checkItemOptionList()
            if(this.optionUse == 0){ //옵션 사용안함
                if(this.stockUse == 1){
                    this.$validate(['stockUse', 'stock','optionUse'])
                }else if(this.stockUse == 0){
                    this.$validate(['stockUse','optionUse'])
                }
            }else{ // 옵션 사용함
                this.$validate(['optionUse','stockUse','optionList'])
            }
        },
        openDeleteConfirm(index){
            this.createConfirm({
                content: '삭제하시겠습니까?',
                confirm: () => {
                    this.optionDelete(index);
                }
            })
            this.checkValidator()
        },
        optionDelete(index){
            let dataCopy = JSON.parse(JSON.stringify(this.optionList))
            dataCopy[index].io_is_delete = 1
            this.optionList.splice(index,1)

            this.parentChange('optionList',  dataCopy)
            this.checkValidator()
        },
        checkItemOption(option){
            if(!util.isEmpty(option.io_type)){
                if(option.io_type == 'option'){
                    return true
                } else if(option.io_type == 'ai'){
                    return false
                }
            } else {
                return true
            }
        },
        checkItemOptionList(){
            this.checkOptionList = this.optionList.filter(item => item.io_type !== 'ai');
        }
    },
    watch: {},
    validators: {
        optionList: function (value) {
            return Validator.value(value)
                .required('옵션을 입력해주세요.')
                .custom(() => {
                    if(this.optionUse === 1 && this.optionList.length < 1) {
                        return '옵션을 입력해주세요.';
                    } else if( this.optionList.length == 1 && this.checkOptionList.length < 1){
                        return '옵션을 입력해주세요.';
                    }
                })
        },
        optionUse: function (value) {
            return Validator.value(value)
        },
        stockUse: function (value) {
            return Validator.value(value)
        },
        stock: function (value) {
            return Validator.value(value)
                .required('재고 수량을 입력해주세요.');
        },
        name: function (value) {
            return Validator.value(value)
                .required('상품명을 입력해주세요.');
        },
        link: function (value) {
            return Validator.value(value)
        },
        manageCode: function (value) {
            return Validator.value(value)
                .required('상품 관리코드을 입력해주세요.');
        },
        price: function (value) {
            return Validator.value(value)
                .required('상품 가격을 입력해주세요.')
                .custom(() => {
                    if (isNaN(value) && value != '') {
                        value = value.replace(/[^0-9]/g, '')
                    }
                    let price = this.price;
                    if (isNaN(price) && price != '') {
                        price = price.replace(/[^0-9]/g, '')
                    }
                    if (value <= 0) {
                        return '상품가격은 0보다 큰 값으로 입력해주세요.'
                    }
                })
        },
    }
}
</script>

<style scoped>

</style>
